<button class="contrast header-button" (click)="toggleWCAG()">
    <i class="bi bi-eye"></i>
    <span *ngIf="wcag.isWCAG" style="text-decoration:underline">
        Dla słabowidzących
    </span>
    <span *ngIf="!wcag.isWCAG" style="text-decoration:underline">
        Wersja graficzna
    </span>
</button>
<button (click)="addFontSize(-2)" class="header-button header-circle" style="color: #fff;">
    <i class="bi bi-type-bold"></i><span>-</span>
</button>
<button (click)="resetFontSize()" class="header-button header-circle" style="color: #fff;">
    <i class="bi bi-type-bold"></i>
</button>
<button (click)="addFontSize(2)" class="header-button header-circle" style="color: #fff;">
    <i class="bi bi-type-bold"></i><span>+</span>
</button>